import type { Messages } from "@prop/i18n";
import type en from "../en/shell";

export default {
  brand: "Funded Lime",
  theme: {
    label: "Tema",
    light: "Claro",
    dark: "Oscuro",
    system: "Sistema",
  },
  language: "Idioma",
  nav: {
    home: "Inicio",
    menu: "Menú principal",
    security: "Seguridad",
    admin: "Admin",
    signOut: "Cerrar sesión",
  },
  home: {
    hello: "Hola, {name}",
    body: "Aquí están tus cuentas de challenge, la terminal y el coach.",
    secureTitle: "Protege tu cuenta",
    secureBody: "Activa la verificación en dos pasos (2FA) antes de empezar a operar.",
    secureAction: "Configurar",
  },
  errors: {
    generic: "Algo salió mal. Inténtalo de nuevo.",
    network: "Sin conexión con el servidor.",
  },
  loading: "Cargando…",
  notFound: "Página no encontrada",
} satisfies Messages<typeof en>;
